import { listValues } from "../listRows";
import type { ListFieldFetch } from "../types";

/** Null when the connector may call any tool; mirrors the proxy's
 * `filters/mcp.rs`, which enforces it. */
export function allowedMcpTools(
  configuration: Record<string, string>
): string[] | null {
  return configuration.toolFilter === "enabled"
    ? listValues(configuration, "tools")
    : null;
}

const MAX_DESCRIPTION_CHARS = 1000;

const nonBlank = (value: unknown): value is string =>
  typeof value === "string" && value.trim() !== "";

function truncate(text: string) {
  const chars = [...text];
  return chars.length > MAX_DESCRIPTION_CHARS
    ? `${chars.slice(0, MAX_DESCRIPTION_CHARS).join("")}…`
    : text;
}

export function mcpToolsExtract(body: string): Array<Record<string, string>> {
  const tools = JSON.parse(body) as Array<{
    name?: unknown;
    title?: unknown;
    description?: unknown;
  }>;
  return tools.flatMap(({ name, title, description }) => {
    if (typeof name !== "string") return [];
    return [
      {
        name,
        ...(nonBlank(title) && { title }),
        ...(nonBlank(description) && { description: truncate(description) }),
      },
    ];
  });
}

export const mcpToolsFetch: ListFieldFetch = {
  label: "Refresh tools",
  protocol: "mcp",
  request: ({ serverUrl }) => serverUrl ?? "",
  extract: mcpToolsExtract,
};
